import React from 'react';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import SubtitleWithLines from 'components/common/SubtitleWithLines';
import { UserRoleTypes } from 'types/aaaService';
import { createStyles } from './styles';
import ChangeAgencyForm from '../ChangeAgencyForm/index';
import RoleTypeCard from './RoleTypeCard';
import SignedInContentWrapper from '../SignedInContentWrapper';

const MultiRoleTypesContent = observer((): JSX.Element => {
  const classes = createStyles();
  // Mobx store
  const {
    roleTypeAndAgencyStore: {
      loading,
      selectedRoleType,
      roleTypes,
      isAgencyFormValid,
      setSelectedRoleType,
      saveAndContinueWithUserSelection,
      sendLogoutUserRequest,
    },
  } = useRootStore();

  const convertedRoleTypes = roleTypes.map((roleType) => toJS(roleType)).slice();

  // Validations
  const isEEValid = Boolean(selectedRoleType && !loading);
  const isAgentValid = Boolean(selectedRoleType && isAgencyFormValid && !loading);

  const onCardClick = (e: React.SyntheticEvent<HTMLLIElement>): void => {
    const roleType = e.currentTarget.dataset.roleType;
    setSelectedRoleType(roleType as UserRoleTypes);
  };

  const RoleTypes = convertedRoleTypes.map((type) => {
    return <RoleTypeCard key={type} type={type} selectedRoleType={selectedRoleType} onCardClick={onCardClick} />;
  });

  return (
    <SignedInContentWrapper
      isValidToContinue={selectedRoleType === 'EE' ? isEEValid : isAgentValid}
      onContinue={saveAndContinueWithUserSelection}
      onLogout={sendLogoutUserRequest}
      sessionLoading={loading}
      content={
        <div>
          <SubtitleWithLines text="Choose the role best fits you" className={classes.subtitle} />
          <ul className={classes.roleTypesList}>{RoleTypes}</ul>
          <div
            // Styles: Hide Change agency form for EMPLOYEE/EMPLOYER with transition
            className={selectedRoleType === 'AGENT' ? '' : classes.hiddenChangeAgencyFormWrapper}
          >
            <ChangeAgencyForm />
          </div>
        </div>
      }
    />
  );
});

export default MultiRoleTypesContent;
